export const getters = {
  athleteList: state => state.athleteList,
  athleteResults: state => state.athleteResults,
  athleteOfficialResults: state => state.athleteOfficialResults,
  resultsList: state => state.resultsList,
  allClubFormData: state => state.allClubFormData,
  allPersonCommunications: state => state.allPersonCommunications,
  clubPersonRel: (state) => {
    if (!state.clubPersonRel || !Array.isArray(state.clubPersonRel.edges)) {
      return [];
    }
    return state.clubPersonRel.edges.map(edge => edge.node);
  }

};
